import { Symbols } from 'Symbols';
import { initValidators, IModelAttributeValidationError, ErrorType } from '../../Util';
import { IndexableModel } from 'Models/Model';
import parsePhoneNumber from 'libphonenumber-js';
import { isNullOrUndefined } from 'Util/TypeGuards';
import { whiteLabelStore } from 'Models/WhiteLabelStore';

export default function validate(allowEmpty?: boolean) {
	return (target: Record<string | symbol, any>, key: string) => {
		initValidators(target, key);
		target[Symbols.validatorMap][key].push('Phone');
		target[Symbols.validator].push(
			(model: IndexableModel): Promise<IModelAttributeValidationError | null> =>
				new Promise(resolve => {
					if (model[key] === null || model[key] === undefined) {
						resolve(null);
					} else if (allowEmpty && model[key] === '') {
						resolve(null);
					} else {
						resolve(
							parsePhoneNumber(model[key], whiteLabelStore.countryCode)?.isValid()
								? null
								: {
										errorType: ErrorType.INVALID,
										errorMessage: 'Enter a valid phone number.',
										attributeName: key,
										target: model,
									},
						);
					}
				}),
		);
	};
}

export function IsValidPhone(phone?: string | null, allowEmpty?: boolean): boolean {
	if (isNullOrUndefined(phone)) {
		return !!allowEmpty;
	}
	return parsePhoneNumber(phone, whiteLabelStore.countryCode)?.isValid() ?? false;
}

export function convertToNationalNumber(number: string) {
	return number.replace(new RegExp(`^${whiteLabelStore.defaultInternationalPhonePrefix}`), '0');
}

export function convertToInternationalNumber(number: string) {
	return number.replace(new RegExp('^0'), whiteLabelStore.defaultInternationalPhonePrefix);
}
export function removePlusFromNumber(number: string) {
	return number.replace(new RegExp('^\\+'), '');
}

export function addPlusToNumber(number: string) {
	return `+${number}`;
}

export function sanitizePhoneNumber(number: string) {
	return number.replace(/[^0-9+\s()-]/g, '');
}
